import { fetch, fetched, reset, insert } from './sponsorships.types'

export const fetchSponsorships = () => ({ type: fetch })
export const fetchedSponsorships = data => ({ type: fetched, data })
export const resetSponsorships = () => ({ type: reset })
export const insertSponsorship = sponsorship => ({ type: insert, sponsorship })
